import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TLabelCustomer } from '../types/label-customer.type';

export const updateLabelCustomerValidationSchema = z.object({
  labelCustomerId: z.string().min(1, { message: 'Label Customer ID is required' }),
  name: z.string().min(1, { message: 'Label Customer name is required' }).optional(),
  color: z.string().min(1, { message: 'Label Customer color is required' }).optional(),
});

export type TUpdateLabelCustomerValidation = z.infer<typeof updateLabelCustomerValidationSchema>;
export type TUpdateLabelCustomerPayload = TUpdateLabelCustomerValidation;
export type TUpdateLabelCustomerResponse = ApiResponse<TLabelCustomer>;

export const updateLabelCustomer = async (
  payload: TUpdateLabelCustomerPayload
): Promise<TUpdateLabelCustomerResponse> => {
  const url = `/label-customer/${payload.labelCustomerId}`;

  const payloadData = {
    name: payload?.name,
    color: payload?.color,
  };

  return axiosInstance.patch(url, payloadData);
};

/**
 * Use Update Label Customer React-Query Hook
 */
type TUseUpdateLabelCustomerMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof updateLabelCustomer, AxiosErrorCustom>;
};

export const useUpdateLabelCustomerMutation = ({ mutationConfigOptions }: TUseUpdateLabelCustomerMutationOptions) => {
  const { ...restConfig } = mutationConfigOptions ?? {};

  return useMutation({
    ...restConfig,
    mutationFn: updateLabelCustomer,
  });
};
